var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgY(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1719107567468,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 21402,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 972.8C260.266667 972.8 51.2 763.733333 51.2 512S260.266667 51.2 512 51.2 972.8 260.266667 972.8 512 763.733333 972.8 512 972.8z m0-853.333333c-217.6 0-392.533333 174.933333-392.533333 392.533333s174.933333 392.533333 392.533333 392.533333 392.533333-174.933333 392.533333-392.533333-174.933333-392.533333-392.533333-392.533333z",
    "p-id": 21403,
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 588.8c-12.8 0-21.333333-4.266667-25.6-17.066667l-128-213.333333c-12.8-17.066667-4.266667-34.133333 8.533333-42.666667 17.066667-8.533333 34.133333-4.266667 42.666667 12.8l128 213.333334c8.533333 17.066667 4.266667 34.133333-12.8 42.666666 0 0-8.533333 4.266667-12.8 4.266667z",
    "p-id": 21404,
    fill: "#333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512 716.8c-17.066667 0-34.133333-12.8-34.133333-34.133333v-128c0-4.266667 0-12.8 4.266666-17.066667l128-213.333333c8.533333-17.066667 29.866667-21.333333 42.666667-12.8 17.066667 8.533333 21.333333 29.866667 12.8 42.666666l-123.733333 204.8V682.666667c4.266667 17.066667-12.8 34.133333-29.866667 34.133333z",
    "p-id": 21405,
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgY);
export default __webpack_public_path__ + "static/media/y.6745cfce07d4b1dd8f3c24cdfa683f95.svg";
export { ForwardRef as ReactComponent };